$ = jQuery;


//Main entrance
$('document').ready(function(){
    
  attachPropertyToInput('.property-ajax', '/wp-json/wp/v2/offer-property/?search_title=');
  attachPropertyToInput('.property-auction-ajax', '/wp-json/wp/v2/auction-property/?search_title=');
    
});

let SELECTED = false;

/**
 * Attach searched property to the input. The searched property is being fetch thru ajax.
 */
const attachPropertyToInput = ( _inputID, _api) => {

  let $input = document.querySelector(_inputID + ' input');
  let $agent = document.getElementById('input_34_35');
  let $sAgent = document.getElementById('input_34_37');

  let $loader = document.getElementById('make-an-offer-loader');
  
  // input event listener for the text input
  if($input) {
    // dynamically create container html for the results then insert it beside the input text
    let resultsContainer = document.createElement('div');
    resultsContainer.classList.add('results-container');
    let parent = document.querySelector('.property-ajax').parentElement;
    $input.parentNode.appendChild(resultsContainer);
    
    
    // if query vars exists - use that as a process
    if( has_query_vars() ) {

      // Process selections
      $input.value = offered_property;
      $input.readOnly = true;
      $agent.value = primary_agent;
      $sAgent.value = secondary_agent;

      SELECTED = true;

    // if no query vars exists - search should be enabled and activate keypress event
    } else {
      let val
      // Keypress event for the search autocomplete input
      $input.addEventListener('keyup', (e) => {

        // Loader event
        $loader.classList.remove('d-none');
        //fetch property data, then filter and show property data matches the user input.
        if($input.value.length >= 3) {

          val = e.target.value;

          let propertyData = axios(_api + val)
              .then( response => response.data )
              .then( data => {

                if( !SELECTED ) {
                  let filteredData = filterPropertyData($input.value, data);

                  if($input.value.length >= 3) {
                    displayPropertyToInput(filteredData, resultsContainer);
                    $loader.classList.add('d-none');
  
                    // attach events for the results.
                    resultsEvents();
                  }
                  
                  
                  
                  
                }
              });
        } //endif

        // fallback for search auto complete when the value is 0,
        // remove the results container 
        if ( $input.value.length == 0 ) {
          resultsContainer.innerHTML = "";
          $loader.classList.add('d-none');
        }

        // Reset selected
        SELECTED = false;

        // Clear results when nothing is selected
        if(e.target.value == '') {
          clearResults();
        }
      });//end event

    } //endif

    

    
  } //endif
}


/**
 * Process the property if query var exists
 * 
 * @returns 
 */
const has_query_vars = () => {
  let $input = document.querySelector('.property-ajax input');
  let $agent = document.getElementById('input_34_35');
  let $sAgent = document.getElementById('input_34_37');
  
  // check if the global variables are existing
  if(typeof offered_property !== 'undefined') {
    return true;
  }

  return false;
}


/**
 * Filter data from input
 * 
 * @param {string} input 
 * @param {array} data 
 * 
 * @return string
 */
const filterPropertyData = (input, data) => {

  if( data.data.length > 0) {
    return data.data
  }
}

/**
 * display property 
 * 
 * @param {Array} filteredData 
 * @param {HTMLAllCollection} html
 * @return void
 */
const displayPropertyToInput = ( filteredData, resultsContainer ) => {
  let html = "";

  // return if we have missing data
  if( filteredData == undefined) {
      html = `<div class="no-result">No Results Found</div>`;
      resultsContainer.innerHTML = html;
      return
  }

  // if filtered data doesn't have any value show html with no results
  if(filteredData.length == 0 ) {
      html = `<div class="no-result">No Results Found</div>`
      resultsContainer.innerHTML = html;
  } else {
    html = filteredData.map(result => {

      let html = `<div class="result"`;

      // add data to agent
      html += `data-agent-email="${result.author.primary_agent.agent_email}" 
              data-agent-name="${result.author.primary_agent.agent_name}"`;

      // add secondary html if available
      if( 'secondary_agent' in result.author  ) {
        html += `data-secondary-agent-email="${result.author.secondary_agent.agent_email}" 
                data-secondary-agent-name="${result.author.secondary_agent.agent_name}"`;
      }

      // add property value
      html += `>${result.property.post_title}
      </div>`;

      return html;
      
    }
    ).join('');
  }

  resultsContainer.innerHTML = html;
}


/**
 * Event listener for results under ajax autocomplete search
 */
const resultsEvents = () => {
  
  const $results = document.querySelectorAll('.results-container .result');
  const $input = document.querySelector('.property-ajax input');
  let $agent_email = document.getElementById('input_34_35');
  let $secondary_agent_email = document.getElementById('input_34_37');

  if($results) {
    $results.forEach( prop => {
      prop.addEventListener('click', () => {
        SELECTED = true;
        $input.value = prop.innerText;
        $agent_email.value = prop.dataset.agentEmail

        if( 'secondaryAgentEmail' in prop.dataset ) {
          $secondary_agent_email.value = prop.dataset.secondaryAgentEmail;
        }


        clearResults();
      });
    });
  }
}


/**
 * Clear the results inside the results container
 */
const clearResults = () => {
  const $resultsContainer = document.querySelector('.results-container');
  const $results = $resultsContainer.querySelectorAll('.result');

  $results.forEach( child => {
    child.remove();
  })
}

  